import VestingABI from './VestingABI.json'

export default {
  netId: 80001,
  updateTime: 35000,
  swapFee: 0.0025,
  BoomLand: {
    address: '0xdBbF0aeB01B059e30A658caF8E79883604bd55c0',
    abi: VestingABI,
  },
  VestingContract: {
    address: '0x3dbC35e90B614837f678e277646b22dd88D5764d',
    abi: VestingABI,
  },
}
